import Button from '../primitives/Button'
import Modal from '../primitives/Modal'
import styles from './PassCheckoutModal.module.css'

interface PassCheckoutModalProps {
  passType: 'individual' | 'team' | 'leader'
  shirtImageUrl?: string
  onClose: () => void
  onProceed: () => void
}

export default function PassCheckoutModal({
  passType,
  shirtImageUrl,
  onClose,
  onProceed,
}: PassCheckoutModalProps) {
  const title =
    passType === 'individual'
      ? 'Individual Pass'
      : passType === 'team'
        ? 'Team Pass'
        : 'Team Leader Pass'

  return (
    <Modal open onClose={onClose} title={title}>
      <div className={styles.body}>
        {shirtImageUrl && (
          <>
            <img
              src={shirtImageUrl}
              alt="Relentless official shirt"
              className={styles.shirt}
            />
            <p className={styles.note}>
              Add the official Relentless shirt to your order during checkout.
            </p>
          </>
        )}
        <Button
          onClick={() => {
            onClose()
            onProceed()
          }}
        >
          Proceed to checkout
        </Button>
      </div>
    </Modal>
  )
}
